import { Pencil, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import type { Project } from '@/types/project'

interface CompanyProjectsTabProps {
	projects: Project[]
	loading: boolean
	onCreate: () => void
	onEdit: (project: Project) => void
	onDelete: (projectId: string) => void
}

export function CompanyProjectsTab({ projects, loading, onCreate, onEdit, onDelete }: CompanyProjectsTabProps) {
	return (
		<Card>
			<CardHeader>
				<div className="flex items-center justify-between">
					<CardTitle>Proyectos</CardTitle>
					<Button disabled={loading} onClick={onCreate}>
						Crear proyecto
					</Button>
				</div>
			</CardHeader>
			<CardContent>
				{loading ? (
					<div className="space-y-3">
						<Skeleton className="h-12 w-full" />
						<Skeleton className="h-12 w-full" />
					</div>
				) : (
					<Table>
						<TableHeader>
							<TableRow>
								<TableHead>Código</TableHead>
								<TableHead>Nombre</TableHead>
								<TableHead className="w-24">Acciones</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{projects.length === 0 ? (
								<TableRow>
									<TableCell colSpan={3} className="text-center text-muted-foreground">
										No hay proyectos
									</TableCell>
								</TableRow>
							) : (
								projects.map((project) => (
									<TableRow key={project.id}>
										<TableCell>{project.code}</TableCell>
										<TableCell className="font-medium">{project.name}</TableCell>
										<TableCell>
											<div className="flex gap-2">
												<Button variant="ghost" size="icon" onClick={() => onEdit(project)}>
													<Pencil className="h-4 w-4" />
												</Button>
												<Button
													variant="ghost"
													size="icon"
													onClick={() => onDelete(project.id)}
												>
													<Trash2 className="h-4 w-4 text-destructive" />
												</Button>
											</div>
										</TableCell>
									</TableRow>
								))
							)}
						</TableBody>
					</Table>
				)}
			</CardContent>
		</Card>
	)
}
